import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import WeatherPreview from '../../SharedComponents/Weather/Previews/FullScreen/WeatherPreview';
import WeatherPreviewPortrait from '../../SharedComponents/Weather/Previews/FullScreen/WeatherPreviewPortrait';
import { Spinner } from 'react-bootstrap';
import { useReadWeatherExternal } from '../../../queries/weather';
import { useDispatch, useSelector } from 'react-redux';
import { setWeatherBgColor, setWeatherCardColor, setWeatherTextColor } from '../../../redux/Slices/Apps/appsSlice';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function Weather() {
    const query = useQuery();
    const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);
    const { weatherTextColor } = useSelector(state => state.apps);
    const dispatch = useDispatch()
    const id = query.get('id');
    const access_token = query.get('token');

    const payload = { media_id: id, token: access_token };

    const { data, isLoading, isError } = useReadWeatherExternal(payload);

    useEffect(() => {
        document.body.classList.add('transparent-body');
        const handleResize = () => {
            const ratio = window.innerWidth / window.innerHeight;
            setIsLandscape(ratio > 1.2);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            document.body.classList.remove('transparent-body');
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    useEffect(() => {
        dispatch(setWeatherTextColor(data?.media?.weather?.settings?.textColor))
        dispatch(setWeatherBgColor(data?.media?.weather?.settings?.bgColor))
        dispatch(setWeatherCardColor(data?.media?.weather?.settings?.CardColor))
    }, [data]);

    if (isLoading && !data) {
        return (
            <div className="h-[100vh] w-[100vw] flex justify-center items-center">
                <Spinner variant="primary" animation="border" size="lg" className="m-3" />
            </div>
        );
    }

    if (isError) {
        return <div className="m-3 text-danger">Error loading weather data.</div>;
    }

    return (
        <div style={{ width: '100vw', height: '100vh' }}>
            {isLandscape ? (
                <WeatherPreview data={data} previewMode={false} />
            ) : (
                <WeatherPreviewPortrait data={data} previewMode={false} />
            )}
        </div>
    );
}

export default Weather;
